
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"13","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.932 6.28L18 10.116V2.281L11.932 6.28zM0 2.281v7.835L6.068 6.28 0 2.28zM16.875 0H1.125C.564 0 .118.418.034.957L9 6.865 17.966.957C17.882.42 17.436 0 16.875 0zM10.901 6.96L9.31 8.007a.562.562 0 01-.618 0l-1.592-1.05-7.063 4.468c.087.534.53.95 1.09.95h15.75c.558 0 1.001-.416 1.088-.95l-7.063-4.467z","fill":"#fff"}})])
          )
        }
      }
    